import {hideShankTopDiamondMilgrain} from '../../../../utils/jewelry-validation'

export const validateShankTopDiamondFields = (filters) => {
  const fieldNames = [
    'diamonds_down_top_of_shank',
    'shape_of_diamonds_down_top_of_shank',
    'distance_diamonds_down_top_of_shank',
    'quality_of_diamonds_down_top_of_shank',
    'setting_style_of_diamonds_down_top_of_shank'
  ]

  const fieldErrorMsgMapping = {
    'diamonds_down_top_of_shank': 'Diamonds Down Top of Shank',
    'shape_of_diamonds_down_top_of_shank': 'Shape of Diamonds Down Top of Shank',
    'distance_diamonds_down_top_of_shank': 'Distance of Diamonds Down Top of Shank',
    'quality_of_diamonds_down_top_of_shank': 'Quality of Diamonds Down Top of Shank',
    'setting_style_of_diamonds_down_top_of_shank': 'Setting Style of Diamonds Down Top of Shank',
    'milgrain_top_of_shank': 'Milgrain Top of Shank'
  }

  // if shank top diamond milgrain is not hidden, then it should be validated
  if (!hideShankTopDiamondMilgrain(filters)) {
    fieldNames.push('milgrain_top_of_shank')
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/shank-top-diamond-fields/index.js